import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import axios from "axios";
import { useSelector } from "react-redux";
import { format } from 'date-fns';
import "./PubBagBody.css"; // Import CSS for custom styling

export default function PubBagBody() {
  const [orderDates, setOrderDates] = useState([]);
  const [loading, setLoading] = useState(true); // Track loading state
  const phoneNo = useSelector(state => state.pubLogin.userPhone);
  const nav = useNavigate();

  useEffect(() => {
    const fetchOrderDates = async () => {
      try {
        const response = await axios.get(`${process.env.REACT_APP_API_URL}/getOrderDates/${phoneNo}`);
        const orderData = response.data;
        const uniqueDates = [...new Set(orderData.map(item => format(new Date(item.OrderDate), 'yyyy-MM-dd')))]; 
        setOrderDates(uniqueDates);
      } catch (error) {
        console.error("Error fetching order dates:", error.message);
      } finally {
        setLoading(false); // Stop loading once data is fetched
      }
    };

    fetchOrderDates();
  }, [phoneNo]); // Include phoneNo in the dependency array to trigger useEffect when it changes

  const handleRowClick = (date) => {
    nav("/pubOrder", { state: { selectedDate: date, phoneNo: phoneNo } });
  };

  return (
    <div className="container">
      <h1 className="text-center mb-3 mt-3 titlecss">My Orders</h1>
      {loading ? (
        <div className="loading-spinner-container">
          <div className="spinner-border" role="status"></div>
        </div>
      ) : orderDates.length === 0 ? (
        <div className="text-center mt-5">
          <h2>Your bag is empty</h2>
          <p>Kindly place an order in your cart</p>
          <button className="btn btn-primary btn-lg" onClick={() => nav("/pubCart")}>
            Go to Cart
          </button>
        </div>
      ) : (
        <div className="table-responsive">
          <table className="table table-bordered table-hover rounded shadow">
            <thead>
              <tr>
                <th className="text-center">Order No.</th>
                <th className="text-center">Date Of Orders</th>
              </tr>
            </thead>
            <tbody>
              {orderDates.map((date, index) => (
                <tr
                  key={index}
                  className={index % 2 === 0 ? "even-row" : "odd-row"}
                  onClick={() => handleRowClick(date)}
                >
                  <td className="text-center">{index + 1}</td>
                  <td className="text-center">{date}</td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      )}
    </div>
  );
}
